<template>
  <transition name="fade">
    <div class="app-message"
    v-if="visible"
    :class="[type ? `app-message-${type}`: '']"
    @click="close"
    >
      <div class="box" :class="[type]">
        <p>{{text}}</p>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    name: 'sgMessage',
    mounted(){
      this.visible = true;
      this.endTime();
    },
    data(){
      return {
        visible: false,
      }
    },
    methods: {
      endTime(){
        setTimeout(()=>{
          this.visible = false;
        }, 3000);
      },
      close(){
        this.visible = false;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/basic/message/src/main.vue